import CONST from './Constant';
import axiosPrivate from '../../../../Setup/Axios/SetupAxios';
import { handleAsyncAction } from "../../../../Setup";

export const setConfig = (payload) => ({
    type: CONST.SET_CONFIG,
    payload,
});

export const setSelectedDepartment = (payload) => ({
    type: CONST.SET_SELECTED_ITEM,
    payload: payload
});

/*****************************************************
 * Fetch Department
 ****************************************************/
export const fetchDepartmentSuccess = (payload) => ({
    type: CONST.FETCH_ITEM_SUCCESS,
    payload: payload
});

export const fetchDepartmentFailed = (payload) => ({
    type: CONST.FETCH_ITEM_FAILED,
    payload: payload
});

export const fetchDepartment = ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get(`roster/departments/${filters['id']}`, {params: filters}),
        [fetchDepartmentSuccess],
        [fetchDepartmentFailed]
    );
};

/*****************************************************
 * Fetch Department
 ****************************************************/
export const fetchDepartmentsSuccess = (payload) => ({
    type: CONST.FETCH_ITEMS_SUCCESS,
    payload: payload
});

export const fetchDepartmentsFailed = (payload) => ({
    type: CONST.FETCH_ITEMS_FAILED,
    payload: payload
});

export const fetchDepartments = ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.get('roster/departments', { params: filters }),
        [fetchDepartmentsSuccess],
        [fetchDepartmentsFailed]
    );
};

/*****************************************************
 * Add Department
 ****************************************************/
export const addDepartmentSuccess = (payload) => ({
    type: CONST.ADD_ITEM_SUCCESS,
    payload: payload
});

export const addDepartmentFailed = (payload) => ({
    type: CONST.ADD_ITEM_FAILED,
    payload: payload
});

export const addDepartment = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.post('roster/departments', data),
        [addDepartmentSuccess],
        [addDepartmentFailed]
    );
};

/*****************************************************
 * Update Department
 ****************************************************/
export const updateDepartmentSuccess = (payload) => ({
    type: CONST.UPDATE_ITEM_SUCCESS,
    payload: payload
});

export const updateDepartmentFailed = (payload) => ({
    type: CONST.UPDATE_ITEM_FAILED,
    payload: payload
});

export const updateDepartment = ({dispatch, data}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.patch(`roster/departments/${data['id']}`, data),
        [updateDepartmentSuccess],
        [updateDepartmentFailed]
    );
};

/*****************************************************
 * Delete Department
 ****************************************************/
export const deleteDepartmentSuccess = (payload) => ({
    type: CONST.DELETE_ITEM_SUCCESS,
    payload: payload
});

export const deleteDepartmentFailed = (payload) => ({
    type: CONST.DELETE_ITEM_FAILED,
    payload: payload
});

export const deleteDepartment = ({dispatch, filters}) => {
    return handleAsyncAction(
        dispatch,
        () => axiosPrivate.delete(`roster/departments/${filters['id']}`),
        [deleteDepartmentSuccess],
        [deleteDepartmentFailed]
    );
};